import React from 'react';
import genericPorImage from '../../../../assets/img/generic_por_image.png';

const PorCarouselGenericItem = () => (
  <div className="carousel-item por-carousel-item">
    <a href={'/por-deals?is_product=true'} className="overlay">
      <div className="por-deal">More deals</div>
      <div>
        <div className="more-information">Click to find out more</div>
      </div>
    </a>
    <img src={genericPorImage} alt='' />
  </div>
);

export default PorCarouselGenericItem;



// WEBPACK FOOTER //
// ./src/components/common/home/carousels/por-carousel-generic-item.jsx